/**
 * Select inviteUser user state slice
 * @param {Object} inviteUser - SavedFilingPeriod state slice.
 * @returns {Object}
 */
export const invitedUserSelector = ({ inviteUser = {} } = {}) =>
  inviteUser.signUp?.model?.user || {};

/**
 * Select inviteUser token state slice
 * @param {Object} inviteUser - SavedFilingPeriod state slice.
 * @returns {string}
 */
export const invitedUserTokenSelector = ({ inviteUser = {} } = {}) =>
  inviteUser.signUp?.model?.userToken;

/**
 * Select inviteUser password state slice
 * @param {Object} inviteUser - SavedFilingPeriod state slice.
 * @returns {string}
 */
export const invitedUserPasswordSelector = ({ inviteUser = {} } = {}) =>
  inviteUser.signUp?.model?.password;

/**
 * Select inviteUser refresh token state slice
 * @param {Object} inviteUser - SavedFilingPeriod state slice.
 * @returns {string}
 */
export const invitedUserRefreshTokenSelector = ({ inviteUser = {} } = {}) =>
  inviteUser.signUp?.model?.refresh || null;
